module.exports = __webpack_public_path__ + "static/1-018-d5256f29b194e2a90f54a14a3a9d1418.png";